import vue from 'vue'
import vueRouter from 'vue-router'
import vueXUI from 'vue-element-xui';
import routeMap from '../../routers'
import { genUrl } from '../utils/query'
import { commitState, readState } from './state';
import { getConfig } from './config'

vue.use(vueRouter);
const router = new vueRouter(routeMap);

let enableRouter = true;

function needLogin(to) {
    let route = null;
    if (routeMap && routeMap.routes) {
        routeMap.routes.forEach(rou => {
            if (!route && new RegExp(rou.path).test(to.path)) {
                route = rou;
            }
        })
    }
    return route.login;
}

router.afterEach((to, from) => {
    if (!enableRouter) {
        return;
    }
    try {
        window.document.title = [to.name, readState('userProfile.customerInfo.name'), [getConfig("customerTitle"), getConfig("customerDesc")].filter(item => {
            return !!item;
        }).join("|")].filter(item => {
            return !!item;
        }).join("-");
    } catch (error) {
    }
})

router.beforeEach((to, from, next) => {
    if (!enableRouter) {
        next();
        return;
    }
    vueXUI.Drawer.closeDrawer();
    if (needLogin(to) && !readState("accessLoggedIn", false)) {
        next({ path: '/login' });
    } else {
        if (to.path == '/login') {
            commitState({
                accessToken: "",
                curStoreGuid: "",
                curStorehouseGuid: "",
                accessLoggedIn: false,
                userProfile: {}
            });
        }
        next();
    }
});

export function reload() {
    window.location.reload();
}

export function setEnableRouter(enable) {
    enableRouter = enable;
}

export function getRouteUrl(path, params = {}, query = {}) {
    return router.resolve({ path, params, query }).href;
}

export function openPageByUrl(targetUrl, newWindow, options) {
    try {
        if (newWindow) {
            window.open(targetUrl, 'new_window', options);
        } else {
            window.location.href = targetUrl;
        }
    } catch (e) {
    }
}

export function openPostPage(url, data = {}) {
    try {
        let form = document.createElement('form')
        form.action = url
        form.method = 'post'
        form.target = '_blank'
        for (let key in data) {
            if (data.hasOwnProperty(key)) {
                let input = document.createElement('input')
                input.type = 'hidden'
                input.name = key
                input.value = data[key]
                form.appendChild(input)
            }
        }
        document.body.appendChild(form);
        form.submit();
    } catch (error) {
    }
}

export function openRoutePage(path, params = {}, query = {}, ro = "") {
    if (`${path}`.indexOf('#') == 0) {
        path = path.substr(1);
    }
    if (`${path}`.indexOf('http') == 0) {
        let defQuery = query.noToken ? {} : { token: readState("userToken") }
        let targetUrl = genUrl(path, Object.assign(defQuery, query || {})) + ro;
        openPageByUrl(targetUrl, query.newWindow);
    } else {
        if (query.newWindow) {
            openPageByUrl(getRouteUrl(path, params, query), query.newWindow);
        } else {
            router.push({ path, params, query });
        }
    }
}

export function openRouteDrawer(path, params = {}, query = {}, refresh = () => { }) {
    let resolve = router.resolve({ path, params, query });
    if (resolve && resolve.route.matched && resolve.route.matched.length > 0) {
        let route = resolve.route.matched[resolve.route.matched.length - 1];
        if (route) {
            vueXUI.Drawer.openDrawer({
                title: route.name,
                component: route.components && route.components.default,
                refresh,
                params,
                query
            }, true)
        }
    }
}

export function replaceRouteDrawer(path, params = {}, query = {}, refresh = () => { }) {
    let resolve = router.resolve({ path, params, query });
    if (resolve && resolve.route.matched && resolve.route.matched.length > 0) {
        let route = resolve.route.matched[resolve.route.matched.length - 1];
        if (route) {
            vueXUI.Drawer.replaceDrawer({
                title: route.name,
                component: route.components && route.components.default,
                refresh,
                params,
                query
            })
        }
    }
}

export default router
